package screens.list

import common.EColors
import common.EConstants
import common.ECssClasses
import components.ButtonContent
import components.Toolbar
import components.alert.Alert
import components.alert.AlertItem
import components.burgerMenu.BurgerMenu
import components.selectColoursFromWatchListItem.SelectColoursFromWatchListItem
import core.AppContext
import core.enums.EImages
import core.enums.ELocalizationKeys
import core.extensions.toClassName
import core.extensions.toColor
import core.ionic.IonButton
import core.ionic.IonCol
import core.ionic.IonContent
import core.ionic.IonGrid
import core.ionic.IonHeader
import core.ionic.IonPage
import core.ionic.IonRow
import core.localStorage.LocalStorageDAO
import core.localization.Localization
import csstype.Display
import csstype.JustifyContent
import csstype.Margin
import csstype.Overflow
import csstype.integer
import csstype.number
import csstype.pct
import csstype.px
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.span
import react.router.Navigate
import react.router.useNavigate
import react.useContext
import react.useEffectOnce
import react.useState
import screens.EScreens
import setUnsafeInnerHTML

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 30.11.22
 * Author : mariorosshirt
 */

external interface SelectableWatchListScreenProps : Props {
}

val SelectableWatchListScreen = FC<SelectableWatchListScreenProps> { props ->

    val mContext by useContext(AppContext)

    val (mLocalStorageState, mLocalStorageDispatch) = mContext.mLocalStorageReducer

    val mNavigate = useNavigate()
    var mTargetScreen: String? by useState(null)
    var mAlertItem: AlertItem? by useState(null)


    useEffectOnce {
        mContext.mLocalStorageReducer.component2().invoke(LocalStorageDAO.ELocalStorageAction.CLEAR_FIXED_LIST)
        mContext.mLocalStorageReducer.component2().invoke(LocalStorageDAO.ELocalStorageAction.CLEAR_SUGGESTED_LIST)
    }

    BurgerMenu()
    IonPage {
        id = EConstants.BURGER_MENU_CONTENT.mId
        IonHeader {
            Toolbar {}
        }

        IonContent {
            IonGrid {
                css(ECssClasses.VERTICAL_GRID.toClassName(), ECssClasses.NON_SCROLLABLE_GRID.toClassName()) {}
                IonRow {
                    IonCol {
                        css() {
                            height = 100.pct
                        }
                        size = "12"
                        if(mLocalStorageState.mFixedList.isEmpty()) {
                            span {
                                css(ECssClasses.LIST_HEADER_FONT.toClassName()) {}
                                setUnsafeInnerHTML(Localization.getLocalizationKey(ELocalizationKeys.S102_HEADER_EMPTY_LIST.name))

                            }
                        } else {
                            span {
                                css(ECssClasses.LIST_HEADER_FONT.toClassName()) {
                                    color = EColors.ORANGE.toColor()
                                }
                                +"${mLocalStorageState.mFixedList.size} von 5"
                            }
                            span {
                                css() {
                                    fontWeight = integer(400)
                                    fontSize = 22.px
                                }
                                +" ausgewählt"
                            }
                        }
                    }
                }
                IonRow {
                    css {
                        flexGrow = number(1.0)
                        overflow = Overflow.scroll
                    }
                    IonCol {
                        css() {
                            height = 100.pct
                        }
                        mLocalStorageState.mWatchlist.forEach {
                            SelectColoursFromWatchListItem() {
                                css() {
                                    minHeight = 112.px
                                }
                                this.mColourObject = it
                                mDeleteFunction =
                                    {
                                        mAlertItem = AlertItem.okAlertItem(
                                            Localization.getLocalizationKey(
                                                ELocalizationKeys.S102_MAX_COLOURS_SELECTED_CONTENT
                                            )
                                        ) {}
                                    }
                            }
                        }
                    }
                }
                IonRow {
                    css {
                        margin = Margin(top = 28.px, horizontal = 20.px, bottom = 0.px)
                    }
                    IonCol {
                        css {
                            padding = 0.px
                        }
                        IonButton {
                            css(ECssClasses.PRIMARY_BUTTON.toClassName()) {
                                display = Display.block
                            }
                            onClick = {
                                mTargetScreen = EScreens.WALL_COLOURER_UPLOAD_SCREEN.mPath
                            }
                            disabled = mLocalStorageState.mFixedList.isEmpty()
                            ButtonContent {
                                mLeftImage = EImages.PAINT_ROLLER_SMALL
                                mContent =
                                    Localization.getLocalizationKey(ELocalizationKeys.S102_SHOW_ON_WALL_BUTTON_CONTENT.name)
                            }
                        }
                    }
                }
                IonRow {
                    css(ECssClasses.BOTTOM_BUTTONS.toClassName()) {}
                    IonCol {
                        css {
                            justifyContent = JustifyContent.spaceBetween
                            display = Display.flex
                            padding = 0.px
                        }
                        IonButton {
                            css(ECssClasses.SECONDARY_BUTTON.toClassName()) {
                                width = 165.px

                            }
                            onClick = {
                                mNavigate.invoke(-1)
                            }
                            ButtonContent {
                                mContent =
                                    Localization.getLocalizationKey(ELocalizationKeys.CORE_BACK.name)
                            }
                        }
                        IonButton {
                            css(ECssClasses.TERTIARY_BUTTON.toClassName()) {
                                width = 165.px
                                //marginBottom = 32.px
                            }
                            onClick = {
                                mContext.mLocalStorageReducer.component2()
                                    .invoke(LocalStorageDAO.ELocalStorageAction.CLEAR_FIXED_LIST)
                            }
                            disabled = mLocalStorageState.mFixedList.isEmpty()
                            ButtonContent {
                                mContent =
                                    Localization.getLocalizationKey(ELocalizationKeys.S102_DESELCT_ALL_BUTTON_CONTENT.name)
                            }
                        }
                    }
                }
            }
        }

    }
    mTargetScreen?.let {
        Navigate {
            to = it
        }
    }
    mAlertItem?.let {
        Alert {
            this.mAlertItem = it
        }
    }
}